import { useMemo, useCallback } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { path } from 'ramda'
import moment from 'moment-timezone'

import CafeteriaOrderRequests from 'app/common/components/Cafeteria/CafeteriaOrderRequests'
import Person from 'app/common/classes/person'
import SimpleDate from 'app/common/classes/simple-date'

import {
  monthFormat,
  dateFormat,
  isMonthly,
  getStudentIdExact,
  getDateExact,
  getSchoolTypeExact,
  params as router,
  createPath,
  cafeteriaOrderRequestsPathMask,
} from 'app/pages/routePaths'

import useSchoolAsCamp from '../useSchoolAsCamp'

type Props = {
  params: any
  router: {
    push: (path: string) => void
  }
}

const OrderRequestsPage = ({ params, router: { push } }: Props) => {
  const studentID = getStudentIdExact(params)
  const dateParam = getDateExact(params)
  const schoolType = getSchoolTypeExact(params)

  const student: any = useSelector(path(['students', 'data', studentID]), shallowEqual)
  const editable: boolean | undefined = useSelector(
    path(['user', 'allow_to_participate_in_orders_students', studentID]),
    shallowEqual,
  )
  const { id: campId } = useSchoolAsCamp(studentID, schoolType)

  const customer = useMemo(() => {
    const { accountId, name, gender, timezone } = student
    return new Person({ id: accountId, ...name, gender, timezone })
  }, [student])

  const [date, monthly] = useMemo(() => {
    const monthlyPeriod = isMonthly(dateParam)
    return [new SimpleDate(dateParam, monthlyPeriod ? monthFormat : dateFormat), monthlyPeriod]
  }, [dateParam])

  const handleChangeDate = useCallback(
    (newDate: string, newDateFormat: string, daily: boolean) => {
      const redirectTo = createPath(
        {
          [router.studentID]: studentID,
          [router.date]: moment(newDate, newDateFormat).format(daily ? dateFormat : monthFormat),
          [router.schoolType]: schoolType,
        },
        cafeteriaOrderRequestsPathMask,
      )
      push(redirectTo)
    },
    [push, studentID, schoolType],
  )

  return (
    <CafeteriaOrderRequests
      customer={customer}
      date={date}
      monthly={monthly}
      editable={editable}
      onChangeDate={handleChangeDate}
      campId={schoolType === 'camp' ? String(campId) : undefined}
    />
  )
}

export default OrderRequestsPage
